import { Link } from "@tanstack/react-router";
import { Compass, ArrowLeft } from "lucide-react";
import { BrandLockup, Button } from "@/components/ui/primitives";

/**
 * Branded 404. Shown by the router's defaultNotFoundComponent for any
 * unmatched URL. Keeps the user inside the product (vs. a bare "Not Found")
 * with a clear path back — "/" redirects to the workspace when signed in and
 * the marketing site otherwise.
 */
export function NotFoundPage() {
  return (
    <main className="argus-glow bg-neutral-975 flex min-h-dvh flex-col items-center justify-center px-6 text-center text-neutral-100">
      <Link to="/" aria-label="Henosis Argus" className="mb-10">
        <BrandLockup size="md" />
      </Link>

      <div className="flex size-12 items-center justify-center rounded-xl border border-neutral-800 bg-neutral-900/60 text-neutral-500">
        <Compass className="size-6" />
      </div>

      <p className="text-brand-400 mt-6 text-xs font-semibold uppercase tracking-widest">
        Error 404
      </p>
      <h1 className="mt-2 text-2xl font-semibold tracking-tight text-neutral-50">
        This page doesn&apos;t exist
      </h1>
      <p className="mt-2 max-w-sm text-sm text-neutral-400">
        The link may be broken or the page may have moved. Let&apos;s get you back to your
        compliance workspace.
      </p>

      <div className="mt-8 flex items-center gap-3">
        <Button variant="ghost" onClick={() => window.history.back()}>
          <ArrowLeft className="size-4" />
          Go back
        </Button>
        <Link to="/">
          <Button variant="primary">Go to Argus</Button>
        </Link>
      </div>
    </main>
  );
}
